import {

  GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS_SUCCESS,
  API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  recordList: [], //Model Data ve Error
  loading: false,
  error: {},
}

const pageOperation = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
      }


    case API_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    default:

      return state

  }
}

export default pageOperation